var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-integral",on:{"click":_vm.getDetail}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/h-icons/integral.svg")}}),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.integral))]),_c('div',{staticClass:"label"},[_vm._v("积分")])])
}
var staticRenderFns = []

export { render, staticRenderFns }